<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="订单编号">
          <el-input v-model="queryParams.orderCode" placeholder="请输入订单编号" clearable/>
        </el-form-item>
        <el-form-item v-if="isAdminUser" label="所属运营商">
          <el-select v-model="queryParams.operatorId" clearable filterable placeholder="请选择运营商">
            <el-option v-for="item in operatorOptions" :key="item.id" :label="item.operatorName" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="queryParams.phone" placeholder="请输入手机号" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button type="success" icon="el-icon-upload" @click="handleImport">Excel导入</el-button>
      <el-button type="success" plain icon="el-icon-upload2" @click="handleCsvImport">CSV导入</el-button>
      <el-button type="info" icon="el-icon-download" @click="handleDownloadTemplate">下载模板</el-button>
      <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      <el-button type="primary" icon="el-icon-upload" @click="handleBatchPush">批量推送</el-button>
      <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
      <input ref="uploadInput" type="file" accept=".xlsx,.xls" style="display:none" @change="handleFileChange">
      <input ref="csvUploadInput" type="file" accept=".csv" style="display:none" @change="handleFileChange">
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="orderList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="所属运营商" prop="operatorName" width="140" show-overflow-tooltip/>
        <el-table-column label="订单编号" prop="orderCode" show-overflow-tooltip/>
        <el-table-column label="手机号" prop="phone" width="120"/>
        <el-table-column label="充电桩编号" prop="pileCode" width="120"/>
        <el-table-column label="充电口编号" prop="portCode" width="120"/>
        <el-table-column label="充电电量 (kWh)" prop="usePower" width="100"/>
        <el-table-column label="开始时间" prop="startTime" width="180"/>
        <el-table-column label="结束时间" prop="endTime" width="180"/>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'warning' : 'success'">
              {{ scope.row.statusDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pushStatus === 1 ? 'success' : (scope.row.pushStatus === 2 ? 'danger' : 'info')">
              {{ scope.row.pushStatusDesc || (scope.row.pushStatus === 1 ? '已推送' : (scope.row.pushStatus === 2 ? '推送失败' : '未推送')) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
            <el-button size="mini" type="text" @click="handlePush(scope.row)">推送</el-button>
            <el-button size="mini" type="text" @click="handleViewPushLog(scope.row)">推送记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <!-- 推送记录对话框 -->
    <el-dialog title="推送记录" :visible.sync="pushLogOpen" width="900px">
      <el-table :data="pushLogList" border>
        <el-table-column label="推送时间" prop="createdTime" width="180"/>
        <el-table-column label="数据类型" prop="dataType" width="100">
          <template slot-scope="scope">
            <el-tag size="mini">{{ getDataTypeLabel(scope.row.dataType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.pushStatus === 1 ? 'success' : 'danger'">
              {{ scope.row.pushStatus === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接口 URL" prop="interfaceUrl" show-overflow-tooltip/>
        <el-table-column label="错误信息" prop="errorMessage" show-overflow-tooltip width="200"/>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleRetryPush(scope.row)">重新推送</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pushLogTotal > 0"
        :current-page.sync="pushLogQuery.pageNum"
        :page-size.sync="pushLogQuery.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pushLogTotal"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="loadPushLog"
        @current-change="loadPushLog"
      />
    </el-dialog>

    <el-dialog :title="title" :visible.sync="open" width="700px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="订单编号" prop="orderCode">
          <el-input v-model="form.orderCode" placeholder="请输入订单编号"/>
        </el-form-item>
        <el-form-item label="充电桩编号" prop="pileCode">
          <el-input v-model="form.pileCode" placeholder="请输入充电桩编号"/>
        </el-form-item>
        <el-form-item label="充电口编号" prop="portCode">
          <el-input v-model="form.portCode" placeholder="请输入充电口编号"/>
        </el-form-item>
        <el-form-item label="用户手机">
          <el-input v-model="form.phone" placeholder="请输入手机号"/>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-input v-model="form.startTime" placeholder="yyyy-MM-dd HH:mm:ss"/>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input v-model="form.endTime" placeholder="yyyy-MM-dd HH:mm:ss"/>
        </el-form-item>
        <el-form-item label="订单状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="1">充电中</el-radio>
            <el-radio label="2">已结束</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结束原因">
          <el-input v-model="form.endReason" placeholder="请输入结束原因"/>
        </el-form-item>
        <el-form-item label="充电电量">
          <el-input v-model="form.usePower" placeholder="请输入充电电量(kWh)"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.mark" type="textarea" placeholder="请输入备注"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="open = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listOrder, getOrder, addOrder, updateOrder, delOrder, pushOrder, pushBatchOrder, importOrder, exportOrder, listPushLog, retryPush } from '@/api/coo/order'
import { listOperator } from '@/api/coo/operator'

export default {
  name: 'OrderList',
  data() {
    return {
      loading: true,
      open: false,
      title: '',
      orderList: [],
      total: 0,
      ids: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderCode: undefined,
        phone: undefined,
        operatorId: undefined
      },
      form: {
        status: '2'
      },
      rules: {
        orderCode: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
        pileCode: [{ required: true, message: '充电桩编号不能为空', trigger: 'blur' }],
        portCode: [{ required: true, message: '充电口编号不能为空', trigger: 'blur' }],
        startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '订单状态不能为空', trigger: 'change' }]
      },
      pushLogOpen: false,
      pushLogList: [],
      pushLogTotal: 0,
      pushLogQuery: {
        pageNum: 1,
        pageSize: 10
      },
      currentOrder: null,
      operatorOptions: [],
      isAdminUser: false
    }
  },
  created() {
    this.initCurrentUser()
    this.initOperatorOptions()
    this.getList()
    this.$guide.startGuideIfNeeded('order')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('order')
    },
    initCurrentUser() {
      const user = JSON.parse(window.sessionStorage.getItem('user') || '{}')
      const roleNames = (user.roles || []).map(item => item.name)
      this.isAdminUser = user.username === 'admin' || roleNames.includes('ROLE_admin')
    },
    initOperatorOptions() {
      if (!this.isAdminUser) {
        return
      }
      listOperator({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.operatorOptions = response.data || []
      })
    },
    getList() {
      this.loading = true
      listOrder(this.queryParams).then(response => {
        this.orderList = response.data
        this.total = response.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderCode: undefined,
        phone: undefined,
        operatorId: undefined
      }
      this.handleQuery()
    },
    getDataTypeLabel(type) {
      const labelMap = {
        station: '站点',
        equipment: '设备',
        port: '充电口',
        order: '订单',
        report: '过程上报',
        alarm: '告警'
      }
      return labelMap[type] || type || '-'
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
    },
    handleAdd() {
      this.form = { status: '2' }
      this.title = '新增订单'
      this.open = true
    },
    handleUpdate(row) {
      getOrder(row.id).then(response => {
        if (response.code === 200) {
          this.form = Object.assign({}, response.data)
          this.title = '编辑订单'
          this.open = true
        } else {
          this.$message.error(response.message || '获取订单失败')
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该订单吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => delOrder(row.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '删除成功')
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '删除失败')
        }
      })
    },
    handlePush(row) {
      pushOrder(row.id).then(response => {
        if (response.code === 200) {
          this.$message.success(response.message || '推送成功')
          this.getList()
        } else {
          this.$message.error(response.message || '推送失败')
        }
      })
    },
    handleBatchPush() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要推送的订单')
        return
      }
      this.$confirm('确认推送选中的订单吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return pushBatchOrder({ orderIds: this.ids })
      }).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '批量推送已启动')
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '批量推送失败')
        }
      })
    },
    handleViewPushLog(row) {
      this.currentOrder = row
      this.pushLogOpen = true
      this.pushLogQuery.pageNum = 1
      this.loadPushLog(row.orderCode)
    },
    loadPushLog() {
      if (!this.currentOrder) return
      const dataId = this.currentOrder.orderCode
      listPushLog({ dataType: 'order', dataId, ...this.pushLogQuery }).then(response => {
        this.pushLogList = response.data || []
        this.pushLogTotal = response.total || 0
      })
    },
    handleRetryPush(log) {
      this.$confirm('确认重新推送该条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return retryPush(log.id)
      }).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '重新推送成功')
          this.loadPushLog()
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '重新推送失败')
        }
      })
    },
    handleDownloadTemplate() {
      const link = document.createElement('a')
      link.href = '/api/coo/template/order/template'
      link.download = '充电订单导入模板.xlsx'
      link.click()
    },
    handleImport() {
      this.$refs.uploadInput.click()
    },
    handleCsvImport() {
      this.$refs.csvUploadInput.click()
    },
    handleExport() {
      exportOrder({}).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '充电订单数据.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      })
    },
    handleFileChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      importOrder(formData).then(response => {
        if (response.code === 200) {
          this.$message.success(`导入完成，成功 ${response.successCount} 条，失败 ${response.failCount} 条`)
          this.getList()
        } else {
          this.$message.error(response.message || '导入失败')
        }
        event.target.value = ''
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const request = this.form.id ? updateOrder(this.form) : addOrder(this.form)
        request.then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '保存成功')
            this.open = false
            this.getList()
          } else {
            this.$message.error(response.message || '保存失败')
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.search-card, .action-card {
  margin-bottom: 15px;
}
</style>
